import {useContext} from 'react'
import {Navigate, Outlet, useNavigate} from 'react-router-dom'
import {FacilityFeature} from '@common/models'

import {ReportsSidebarNav} from './ReportsSidebarNav'

import {Layout} from '~/components/layout/Layout'
import {PractitionerContext} from '~/components/profile/PractitionerContext'
import {useNavigationType} from '~/hooks/useNavigationType'

export const ReportsManagementPage = () => {
  const navigate = useNavigate()
  const {isPractitionerOnly} = useNavigationType()
  const {selectedEmployment} = useContext(PractitionerContext)
  const hasPartner = Boolean(selectedEmployment?.hasPartner)
  const hasScreening = Boolean(
    selectedEmployment?.features?.includes(FacilityFeature.SCREENING),
  )
  const fullPath = '/app/reports/'

  if (isPractitionerOnly && !hasPartner) {
    return (
      <Navigate
        replace
        to={hasScreening ? '/app/appointments' : '/app/patients'}
      />
    )
  }

  return (
    <Layout
      fullWidth
      sideNav={
        <ReportsSidebarNav
          fullPath={fullPath}
          onClick={(id) => navigate(`${fullPath}${id}`)}
        />
      }
      navMenu={null}>
      <Outlet />
    </Layout>
  )
}
